import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

export default function CommunityPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="legal-back">← Back to Godly Match</Link>
        <h1>Community Guidelines</h1>
        <p className="legal-effective">Last updated: 7 May 2026</p>

        <p>Godly Match exists to help Christians find meaningful, faith-centred relationships. These guidelines keep it a safe, honest, and respectful space for everyone.</p>

        <hr className="legal-divider" />

        <h2>Be Authentic</h2>

        <h3>Use real photos of yourself</h3>
        <p>Your primary photo must clearly show your face. No group shots, celebrity photos, or avatars as your main photo.</p>

        <h3>Be honest in your bio</h3>
        <p>Describe yourself accurately. Misrepresenting your faith, background, or appearance is unfair to everyone you match with and erodes trust in the community.</p>

        <h3>One account per person</h3>
        <p>Creating multiple accounts to evade a ban or game the platform is not allowed.</p>

        <hr className="legal-divider" />

        <h2>Be Respectful</h2>

        <h3>Treat everyone with dignity</h3>
        <p>Rejection is a normal part of dating — handle it graciously. No reply is a complete answer. Do not pressure people who have not responded.</p>

        <h3>No harassment</h3>
        <p>Sending repeated unwanted messages after someone has not responded, or has asked you to stop, is harassment and will result in a ban.</p>

        <h3>No hate speech</h3>
        <p>Discrimination or derogatory language based on race, ethnicity, denomination, disability, or any other characteristic is not tolerated.</p>

        <h3>Keep it appropriate</h3>
        <p>Explicit sexual content or requests have no place on a faith-based platform.</p>

        <hr className="legal-divider" />

        <h2>Be Safe</h2>

        <h3>Never send money</h3>
        <p>If someone on Godly Match asks you for money, gift cards, or involves you in any financial scheme — that is a scam. Report them immediately and do not send anything.</p>

        <h3>Meet in public first</h3>
        <p>When meeting someone from the app in person for the first time, choose a public place and tell a trusted friend or family member where you are going.</p>

        <h3>Protect your personal details</h3>
        <p>Be cautious about sharing your home address, workplace, or daily routine early in a conversation with someone you have just met.</p>

        <hr className="legal-divider" />

        <h2>What We Do Not Allow</h2>
        <p>The following result in immediate account removal:</p>
        <ul>
          <li>Nudity or sexually explicit content</li>
          <li>Any content involving minors in a sexual context — reported to authorities without exception</li>
          <li>Violence or threats of violence</li>
          <li>Fake profiles or catfishing</li>
          <li>Soliciting money, gifts, or financial information</li>
          <li>Spam or unsolicited promotional content</li>
          <li>Encouraging users to leave the platform to bypass our safety systems</li>
        </ul>

        <hr className="legal-divider" />

        <h2>How We Enforce These Guidelines</h2>

        <h3>Photo moderation</h3>
        <p>All uploaded photos are automatically screened for inappropriate content. Flagged photos are reviewed by our moderation team before being approved.</p>

        <h3>Reporting</h3>
        <p>Every profile has a report button. All reports are reviewed by a human member of our team, not just an algorithm.</p>

        <h3>Blocking</h3>
        <p>You can block any user at any time. Blocked users cannot see your profile or contact you.</p>

        <h3>Bans</h3>
        <p>Violations result in warnings, temporary suspensions, or permanent bans depending on severity. Exploitation, threats, and illegal content result in immediate permanent bans with no appeal.</p>

        <hr className="legal-divider" />

        <h2>How to Report Someone</h2>
        <ol>
          <li>Open their profile</li>
          <li>Tap the three-dot menu (⋮) in the top right</li>
          <li>Select <strong>Report User</strong></li>
          <li>Choose a reason and add any details</li>
          <li>Submit</li>
        </ol>
        <p>For urgent safety concerns email support@godlymatch.org. We review every report and never tell the reported person who filed it.</p>

        <hr className="legal-divider" />

        <h2>A Note on Faith</h2>
        <p>Godly Match welcomes Christians of all denominations. We do not adjudicate theological disputes or declare one tradition correct over another. Denomination filtering exists to help people find compatible partners — nothing more. Respect for fellow believers, even those whose practice differs from yours, is expected.</p>

        <p><em>These guidelines will evolve as the community grows. The spirit behind them will not: this is a place built on respect, honesty, and faith.</em></p>
      </div>
    </div>
  );
}